import { Component, Host, h } from '@stencil/core';
import { dayjs } from '../../utils/dayjs';

@Component({
  tag: 'me-portal-header',
  styleUrl: 'me-portal-header.scss',
  shadow: false,
})
export class MePortalHeader {

  render() {
    const date = dayjs().format('dddd, DD.MM.YYYY');

    return (
      <Host class="me-portal-header">
        <section class="me-portal-header__upper">
          <div class="me-portal-header__body">
            <span class="me-portal-header__date">
              {date}
            </span>
            <span class="me-portal-header__actions">
              <slot name="actions"></slot>
            </span>
          </div>
        </section>
        <section class="me-portal-header__lower">
          <div class="me-portal-header__body">
            <span class="me-portal-header__logo">
              <slot name="logo"></slot>
            </span>
          </div>
        </section>
      </Host>
    );
  }

}
